import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { RouterModule } from '@angular/router';

import { AddressModule } from '@shared/address/address.module';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { CardsModule } from '@shared/cards/cards.module';
import { IconsModule } from '@shared/icons/icons.module';
import { DocumentModule } from '@shared/document/document.module';
import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { MutualModule } from '@shared/mutual/mutual.module';

import {
  CompanyBlockCardComponent,
  CompanyBondCardComponent,
  CompanyDependencyDetailsComponent,
  CompanyDetailsComponent,
  CompanyListAdminComponent,
  CompanySubBlockCardComponent,
} from './components';
import { NgxPaginationModule } from 'ngx-pagination';
import { CompanyBondRequestCardComponent } from './components/company-bond-request-card/company-bond-request-card.component';
import { CompanySearchSelectComponent } from './components/company-search-select/company-search-select.component';
import { DeleteCompanyModalComponent } from './components/delete-company-modal/delete-company-modal.component';
import { LhcbCouponBannerComponent } from './components/lhcb-coupon-banner/lhcb-coupon-banner.component';
import { LhcbMigrationModalComponent } from './components/lhcb-migration-modal/lhcb-migration-modal.component';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ManagementSharedModule } from '@shared/management-shared/management-shared.module';

@NgModule({
  declarations: [
    CompanyDetailsComponent,
    CompanyBondCardComponent,
    CompanyDependencyDetailsComponent,
    CompanyListAdminComponent,
    CompanyBondRequestCardComponent,
    CompanySearchSelectComponent,
    CompanyBlockCardComponent,
    CompanySubBlockCardComponent,
    DeleteCompanyModalComponent,
    LhcbCouponBannerComponent,
    LhcbMigrationModalComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    AddressModule,
    PipesSharedModule,
    CardsModule,
    IconsModule,

    DocumentModule,
    RouterModule,
    CustomModalModule,
    MutualModule,
    NgxPaginationModule,
    FormWrapperModule,
    BsDropdownModule.forRoot(),
    ManagementSharedModule,
  ],
  exports: [
    CompanyDetailsComponent,
    CompanyBondCardComponent,
    CompanyListAdminComponent,
    CompanyBondRequestCardComponent,
    CompanySearchSelectComponent,

    CompanyBlockCardComponent,
    CompanySubBlockCardComponent,
    DeleteCompanyModalComponent,
    LhcbCouponBannerComponent,
    LhcbMigrationModalComponent,
  ],
})
export class CompanySharedModule {}
